import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import { 
    FriendRequestsAction, 
    FriendRequestsActionType, 
    LoadFriendRequestsAction, 
    LoadFriendRequestsSucceededAction, 
    LoadFriendRequestsFailedAction, 
    AcceptFriendRequestAction,
    AcceptFriendRequestSucceededAction,
    AcceptFriendRequestFailedAction,
    DenyFriendRequestAction,
    DenyFriendRequestSucceededAction,
    DenyFriendRequestFailedAction
} from './friendRequests.actions';
import { FriendRequestsService } from '../../firebase/friendRequests.service';
import { ConversationsStoreDispatcher } from '../conversations/conversations.dispatcher'


@Injectable()
export class FriendRequestsEffects {

    
    loadFriendRequests$: Observable < FriendRequestsAction > = createEffect(() => this.actions$
        .pipe(
            ofType(FriendRequestsActionType.LOAD_FRIEND_REQUESTS),
            switchMap((action: LoadFriendRequestsAction) => {
                this.loadingCtrl.present('general');
                return from(this.friendRequestsService.loadFriendRequests()
                    .then(invitations => {
                        return new LoadFriendRequestsSucceededAction(invitations);
                    })
                    .catch(error => {
                        return new LoadFriendRequestsFailedAction({
                            'error': error
                        });
                    })
                    .finally(() => {
                        this.loadingCtrl.dismiss('general');
                    })
                );
            })
        ));

    
    acceptFriendRequest$: Observable < FriendRequestsAction > = createEffect(() => this.actions$
        .pipe(
            ofType(FriendRequestsActionType.ACCEPT_FRIEND_REQUEST),
            switchMap((action: AcceptFriendRequestAction) => {
                return from(this.friendRequestsService.acceptFriendRequest(action.userID)
                    .then(() => {
                        this.toastr.success('You are now connected.', '', {
                            positionClass: 'toast-bottom-center'      
                        });
                        // Create New Conversation with user uid
                        this.conversationsStoreDispatcher.createNewConversation(action.userID);
                        
                        return new AcceptFriendRequestSucceededAction(action.userID);
                    })
                    .catch(error => {
                        return new AcceptFriendRequestFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    
    denyFriendRequest$: Observable < FriendRequestsAction > = createEffect(() => this.actions$
        .pipe(
            ofType(FriendRequestsActionType.DENY_FRIEND_REQUEST),
            switchMap((action: DenyFriendRequestAction) => {
                return from(this.friendRequestsService.denyFriendRequest(action.userID)
                    .then(() => {
                        return new DenyFriendRequestSucceededAction(action.userID);
                    })
                    .catch(error => {
                        return new DenyFriendRequestFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    constructor(private friendRequestsService: FriendRequestsService,
        private actions$: Actions,
        private loadingCtrl: SopoLoadingService,
        private toastr: ToastrService,
        private conversationsStoreDispatcher: ConversationsStoreDispatcher) {
        
    }
}
